import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSocket } from "redux/chats/chats.actions";

function LogoutModal({ setShowLogoutModal, showLogoutModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getTranslation } = useTranslation("COMMON");
  const { t } = getTranslation();

  const handleLogoutUser = async () => {
    dispatch(logoutSocket({ navigate }));
  };

  return (
    <Modal
      setVisibility={setShowLogoutModal}
      visible={showLogoutModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {t("MODAL").LOGOUT_CONFIRMATION}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={() => setShowLogoutModal(false)}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("MODAL").CANCEL}
          </button>
          <button
            onClick={() => {
              handleLogoutUser();
              setShowLogoutModal(false);
            }}
            className="btn btn-primary"
          >
            {t("MODAL").CONFIRM}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default LogoutModal;
